<template>
  <i :class="'uk-icon-' + name"></i>
</template>

<script>
  export default {
    name: 'ElIcon',

    props: {
      name: String
    }
  };
</script>



// WEBPACK FOOTER //
// packages/icon/src/icon.vue